import React, { useEffect, useContext } from 'react';
import { Context } from '@routes/private/Editor/Context';
import {IProps, IState} from './types';
import * as S from './styles';
import { findElementById } from '@utils/editor';
import { IElement, IElementType, ITextAttributes } from '@routes/private/Editor/types';
import { isEditingText } from '@utils/text';
import { findCommonAttributeValue } from "@utils/editor";

const Keyboard:React.FC<IProps> = (props) => {
  const context = useContext(Context);

  const keydownHandler = (e:any) => {
    if ((e.key==="b" || e.key==="i" || e.key==="u" || e.key==="y" || e.key==="+" || e.key==="-" || e.key==="=") && (e.ctrlKey || e.metaKey)) {
      e.cancelBubble = true;
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", keydownHandler);
    return () => document.removeEventListener("keydown", keydownHandler);
  }, []);
  
  return (
    <S.Root
      id="rootKeyboard" 
      onKeyDown={(e)=>{
        if (context.searchImages) return;
        if (context.editorStatus.selectedElementsId.length>0)
        {
            let element = findElementById(context.data, context.editorStatus.selectedElementsId[0]);
            //Ctrl + B || Command + B --> Bold
            if (e.key=="b" && (e.ctrlKey || e.metaKey) && element){
              const fontWeight = findCommonAttributeValue(context.editorStatus.selectedElementsId, context.data, "fontWeight", "Text", context.editorStatus.textSelectionInformation);
              const someOneNotBold = !fontWeight;
              context.onCommandChange("fontWeight", someOneNotBold);          
            }                   
            //Ctrl + I || Command + I --> Italic
            if (e.key=="i" && (e.ctrlKey || e.metaKey) && element) {
              const fontItalic = findCommonAttributeValue(context.editorStatus.selectedElementsId, context.data, "fontItalic", "Text", context.editorStatus.textSelectionInformation);
              const someOneNotItalic = !fontItalic;
              context.onCommandChange("fontItalic", someOneNotItalic);          
            }
            //Ctrl + U || Command + U --> Underline
            if (e.key=="u" && (e.ctrlKey || e.metaKey) && element) {
              const fontUnderline = findCommonAttributeValue(context.editorStatus.selectedElementsId, context.data, "fontUnderline", "Text", context.editorStatus.textSelectionInformation);
              const someOneNotUnderline = !fontUnderline;
              context.onCommandChange("fontUnderline", someOneNotUnderline);          
            }
        }
        //Ctrl + Z || Command + Z --> Undo
        if (e.key=="z" && (e.ctrlKey || e.metaKey)) context.onUndoRedo("undo");

         //Ctrl + Y || Command + Y --> Undo
         if (e.key=="y" && (e.ctrlKey || e.metaKey)) context.onUndoRedo("redo");

        //Ctrl + C || Command + C --> Undo
        if (!isEditingText(e) && e.key=="c" && (e.ctrlKey || e.metaKey))
          context.onCommandChange("copypaste", {copy: true, paste: false});

         //Ctrl + V || Command + V --> Undo
        //if (!isEditingText(e) && e.key=="v" && (e.ctrlKey || e.metaKey))
        //  context.onCommandChange("copypaste", {copy: false, paste: true});

         //delete
        if (!context.editorStatus.isPickerFocused && !isEditingText(e) && ((e.keyCode||e.charCode)===8 || (e.keyCode||e.charCode)===46)) context.onCommandChange("removeElement");

        //Ctrl + || Command + --> Zoom +
        if ((e.key=="+" && (e.ctrlKey || e.metaKey))
        || (e.key=="=" && (e.ctrlKey || e.metaKey) && e.shiftKey)
        || (e.key=="=" && (e.ctrlKey || e.metaKey))) context.onZoomChange(context.editorStatus.zoom.value+5);

        //Ctrl - || Command - --> Zoom -
        if (e.key=="-" && (e.ctrlKey || e.metaKey)) context.onZoomChange(context.editorStatus.zoom.value-5);

        //Spacebar --> activate dragging
        if (e.key === " ") context.onDraggingChange(true);

        //Escape --> inactivate dragging
        if (e.key === "Escape") context.onDraggingChange(false);

        if (e.shiftKey && !(e.ctrlKey || e.metaKey)) context.onHandleShift(true);
      }} 
      onKeyUp={(e) => {
        if (e.key === "Shift") context.onHandleShift(false);
        if (e.key === " ") context.onDraggingChange(false);
      }}
      tabIndex={0}
    >
      {props.children}        
    </S.Root>
  );
}

export default Keyboard;